<template>
  <div class="sub-comment-item">
    <div class="comment-wrapper">
      <div class="avatar-wrapper">
        <UserCardToggle :id="data.from.id">
          <el-avatar size="small" shape="square" class="avatar" :src="data.from.avatar"
                     @click.native="goSpace(data.from.id)"></el-avatar>
        </UserCardToggle>
      </div>
      <div class="right-wrapper">
        <div @mouseenter="operationShowFlag = true" @mouseleave="operationShowFlag = false">
          <div class="operation" v-show="operationShowFlag">
            <el-link icon="el-icon-delete" :underline="false" v-if="isMaster || isMine" @click="deleteReply">删除</el-link>
            <el-link icon="el-icon-s-comment" :underline="false" v-if="!isMine" @click="replyTrigger">回复</el-link>
          </div>
          <div class="content-wrapper">
            <div class="info">
              <span class="name">{{ fromName }}</span>
              <Author v-if="masterId === data.from.id"></Author>
              <span class="reply">回复</span>
              <span class="name">{{ toName }}</span>
              <Author v-if="masterId === data.to.id"></Author>
              <span class="mine-text-grey date">{{ data.date }}</span>
            </div>
            <TextAutoContainer class="text-content" :content="data.content"></TextAutoContainer>
          </div>
        </div>
        <TriggerDisplayContainer class="comment-editor" ref="commentEditorC" @callback="$refs.commentEditor.focus()">
          <CommentEditor @submit="submit" ref="commentEditor" :enablePicture="false"
                         :enableAt="false" :placeholder="'回复 ' + fromName" :submitFlag="commentSubmitFlag"></CommentEditor>
        </TriggerDisplayContainer>
      </div>
    </div>
  </div>
</template>

<script>
    import TextAutoContainer from '../baseComponent/TextAutoContainer'
    import UserCardToggle from '../userCard/UserCardToggle'
    import CommentEditor from '../component/CommentEditor'
    import TriggerDisplayContainer from "../baseComponent/TriggerDisplayContainer"
    import Author from "../icon/title/Author"
    import IsMine from "../baseComponent/IsMine"
    import {clone} from "../../js/utils/objUtils";

    export default {
        name: "LiveReplyItem",
        mixins: [IsMine],
        components: {TextAutoContainer, UserCardToggle, CommentEditor, TriggerDisplayContainer, Author},
        props: {
            data: {
                type: Object,
                required: true
            },
            masterId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                commentSubmitFlag: false,
                operationShowFlag: false,
            }
        },
        created() {
            this.setUserId(this.data.from.id);
        },
        methods: {
            submit(content) {
                this.commentSubmitFlag = true;
                this.$im.post("/SPACE/v1/live-replies", {replyId: this.data.id, content: content}, true, (id) => {
                    this.$refs.commentEditor.clean();
                    this.replyTrigger();
                    this.$im.getInfo((info) => {
                        //回复完成回调通知父组件
                        this.$emit('submitCallback', this.data.id, {id: id, content: content, date: '1秒前', from: clone(info), to: clone(this.data.from)});
                    });
                }, () => {
                    this.commentSubmitFlag = false;
                });
            },
            replyTrigger() {
                this.$refs.commentEditorC.trigger()
            },
            deleteReply() {
                this.$emit('delete');
            },
            goSpace(uId) {
                if (!this.isMine) {
                    this.$router.push("/spaces/" + uId);
                }
            }
        },
        computed: {
            fromName() {
                return this.data.from.remarks ? this.data.from.remarks : this.data.from.name
            },
            toName() {
                return this.data.to.remarks ? this.data.to.remarks : this.data.to.name
            },
            isMaster() {
                return this.masterId === this.mineId;
            }
        },
    }
</script>

<style scoped>
  .sub-comment-item {
  }

  .comment-wrapper {
    display: flex;
    width: 100%;
  }

  .avatar-wrapper {
    margin-right: 8px;
  }

  .avatar {
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  }

  .right-wrapper {
    width: 100%;
  }

  .content-wrapper {
    padding-right: 60px;
  }


  .mine-text-grey {
    font-size: 12px;
    color: #999;
  }


  .info {
    display: flex;
    align-items: end;
    margin-bottom: 4px;
  }

  .info > *{
    margin-right: 5px;
  }

  .info .reply {
    color: #999;
    font-size: 12px;
  }

  .date {
    align-self: end;
  }

  .comment-editor {
    padding: 12px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 8px 0;
  }

  .operation {
    float: right;
  }

  .operation > * {
    margin-left: 5px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/view/component/LiveReplyItem.vue